module.exports = __webpack_public_path__ + "static/media/sports.7936039f.svg";